import ValidateAddressDialog from './ValidateAddressDialog';
import ConnectedValidateAddressDialog from './ConnectedValidateAddressDialog';

export { ValidateAddressDialog };
export default ConnectedValidateAddressDialog;
